import { Link } from 'react-router-dom';
import { modules, getModuleIcon } from '../data/modules';
import { ScrollArea } from '../components/ui/scroll-area';

export default function Sidebar({ currentModule }) {
  return (
    <aside className="hidden lg:block w-64 shrink-0 border-r border-border bg-card" data-testid="sidebar">
      <ScrollArea className="h-[calc(100vh-64px)]">
        <div className="p-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] mb-4 px-2" style={{ color: 'var(--i3-teal)' }}>Training Modules</p>
          <nav className="space-y-0.5">
            {modules.map((mod) => {
              const Icon = getModuleIcon(mod.icon);
              const isActive = currentModule === mod.id;
              return (
                <Link key={mod.id} to={`/module/${mod.id}`} data-testid={`sidebar-module-${mod.id}`}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all group ${
                    isActive ? 'bg-accent text-accent-foreground font-medium' : 'text-muted-foreground hover:bg-accent hover:text-foreground'
                  }`}>
                  <Icon className={`w-4 h-4 shrink-0 ${isActive ? '' : 'group-hover:text-foreground'}`}
                    style={isActive ? { color: 'var(--i3-teal)' } : {}} strokeWidth={1.5} />
                  <span className="truncate">{mod.title}</span>
                  <span className={`ml-auto text-[10px] font-medium px-1.5 py-0.5 rounded-full ${isActive ? 'bg-[#42CDD7]/20 text-[#42CDD7]' : 'bg-muted text-muted-foreground'}`}>
                    {mod.steps.length}
                  </span>
                </Link>
              );
            })}
          </nav>
        </div>
      </ScrollArea>
    </aside>
  );
}
